/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
import state from "../state.js"
import store from '@/store/store.js'

//  ::aiExam/actions,store.commit("exam/SET_EXAM_SUBJECT_LIST", response.data.data_list)
export default {  //  ::aiExam/actions  
  getTipsExamQuestionList(context, examSubjectId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v3/ai_system/tips/exam_subject/question_list?exam_subject_id=${examSubjectId}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTipsExamQuestionDetail(context, questionId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v3/ai_system/tips/exam_subject/question/detail?question_id=${questionId}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTipsExamSubjectList(context) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v3/ai_system/tips/exam_subject")
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  uploadTipsExamSubjectFile(context, payload) {
    const frm = new FormData()
    frm.append("file", payload.file)

    return new Promise((resolve, reject) => {
      axios.post("/api/v3/ai_system/tips/exam_subject/upload", frm, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // AI > 생성(고등) > 기출 AI ... [
  // 생성된 시험의 정보 가져오기
  getSubjectDetail({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_exam_subject?id=" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            store.commit("exam/SET_SUBJECT_DETAIL", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // (생성된 시험 가져오는거)
  getAllExamSubject({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_exam_subject_list").then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_EXAM_SUBJECT_LIST", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // (생성된 시험 정보 추가 및 수정 후 완료)
  editExamSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/auto_exam_subject", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // (완료된 시험 입력 허용으로 제출)
  sendReview(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/auto_exam_subject_done?id=" + payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // [시험 만들기] (시험 만들기 전 동작 순서1)
  createExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/exam", payload).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_ACTIVE_EXAM_ID", response.data.data.id)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // [시험 만들기] (시험 만들기 전 동작 순서2)
  createExamSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/auto_exam_subject", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // [시험 만들기] (시험 만들기 전 동작 순서3)
  getExamSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_exam_subject_exam/" + payload).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_EXAM_SUBJECT", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // [시험 만들기] (시험id 없을 경우 사용)
  editExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/exam", payload).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_ACTIVE_EXAM_ID", response.data.data)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // [시험 만들기] (위에서 생성된 시험 개별 삭제)
  deleteExamSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/exam/auto_exam_subject/" + payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // [시험 만들기] (위에서 생성된 시험 전체 삭제)
  deleteExam(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/exam/auto_exam/" + payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 시험생성 만들 예정인 시험이 기존에 있는지 확인(기출, 기출AI 둘다 사용) 서로 시험이 겹치는지 확인용으로 사용됨
  getCheckCreateExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/exam/check?grade_id=" + payload.grade_id + "&release_time=" + payload.release_time).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // ]


  // AI > 문제검토 ... [
  // 문제검토 시험 전체 리스트 가져오기
  getAiExamList() {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_review_exam").then((response) => {
        if (response.data.result == 'success') {
          console.log(response.data.data_list);
          if (response.data.data_list.length > 0) {
            var allowedExamList = [];
            var userAllowedExamList = [];
            for (var i = 0; i < response.data.data_list.length; i++) {
              // state3&&admin_check   1: 검토 대기, 2: 검토 중, 3: 문제 신고,
              //state4&&admin_check5: 검토 완료

              // state3&&admin_check   1: 검토할 시험, 2: 검토 중인 시험, 4: 검토 완료, state4&&admin_check5: 승인 완료

              if (response.data.data_list[i].state == 3) {
                if (response.data.data_list[i].admin_check == 1) {
                  allowedExamList.push(response.data.data_list[i]);
                } else {
                  userAllowedExamList.push(response.data.data_list[i]);
                }
              } else {
                userAllowedExamList.push(response.data.data_list[i]);
              }
            }
            if (allowedExamList.length > 0) store.commit("exam/SET_ALLOWED_EXAM_LIST", allowedExamList); // 검토할 시험
            // 검토할 시험을 제외한 전체 시험(검토 중인 시험, 검토 완료, 승인 완료)
            if (userAllowedExamList.length > 0) store.commit("exam/SET_AI_USER_ALLOWED_EXAM_LIST", userAllowedExamList)
          }
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getAiExamListNew() {
    return new Promise((resolve, reject) => {
      axios.get("/api/v4/exam/review_exam").then((response) => {
        if (response.data.result == 'success') {
          console.log(response.data.data_list);
          if (response.data.data_list.length > 0) {
            var allowedExamList = [];
            var userAllowedExamList = [];
            for (var i = 0; i < response.data.data_list.length; i++) {
              // state3&&admin_check   1: 검토 대기, 2: 검토 중, 3: 문제 신고,
              //state4&&admin_check5: 검토 완료

              // state3&&admin_check   1: 검토할 시험, 2: 검토 중인 시험, 4: 검토 완료, state4&&admin_check5: 승인 완료

              if (response.data.data_list[i].state == 3) {
                if (response.data.data_list[i].admin_check == 1) {
                  allowedExamList.push(response.data.data_list[i]);
                } else {
                  userAllowedExamList.push(response.data.data_list[i]);
                }
              } else {
                userAllowedExamList.push(response.data.data_list[i]);
              }
            }
            if (allowedExamList.length > 0) store.commit("exam/SET_ALLOWED_EXAM_LIST", allowedExamList); // 검토할 시험
            // 검토할 시험을 제외한 전체 시험(검토 중인 시험, 검토 완료, 승인 완료)
            if (userAllowedExamList.length > 0) store.commit("exam/SET_AI_USER_ALLOWED_EXAM_LIST", userAllowedExamList)
          }
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  // 검토 모니터링(관리자): 제출완료/승인완료 이력을 컷오프 없이 조회. userId 없으면 전체 알바생 통합 조회, keyword/subjectTypeId/gradeId로 필터링 가능
  getReviewExamCompletedHistory(context, payload) {
    const { userId, keyword, subjectTypeId, gradeId } = payload || {}
    return new Promise((resolve, reject) => {
      axios.get("/api/v4/exam/review_exam_completed_history", {
        params: { user_id: userId || undefined, keyword: keyword || undefined, subject_type_id: subjectTypeId || undefined, grade_id: gradeId || undefined }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data_list)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검토 모니터링(관리자): 특정 날짜의 승인완료 시험지 수 / 앱 적용 문제수(has_error=1 완전오류만 제외) 집계
  getReviewExamCompletedStats(context, date) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v4/exam/review_exam_completed_stats", {
        params: { date }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검토 모니터링(관리자): 특정 날짜의 승인완료 시험지 목록(전체 알바생 통합)
  getReviewExamCompletedList(context, date) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v4/exam/review_exam_completed_list", {
        params: { date }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data_list)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검토 모니터링(관리자): 검토자를 승인해서 스케줄러 반영 대상에 포함시킴
  approveReviewUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v4/exam/review_exam_approve_user", { user_id: userId }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // (문제검토 전체  시험 가져오는 것 같음)
  getUserAllowExam({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("api/v2/exam/auto_enter_exam_user?user_id=" + payload).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_USER_ALLOWED_EXAM_LIST", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // (문제검토 입력할 시험만 가져옴)
  getAllowExam({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_enter_exam").then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_ALLOWED_EXAM_LIST", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 문제 검토 시험 상태값 변경
  changeAiExamState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/v2/exam/auto_review_exam?type=${payload.type}&id=${payload.id}&admin_check=${payload.admin_check}&state=${payload.state}&mark=${payload.mark}`).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  changeAiExamStateNew(context, payload) {
    const adminCheckLabel = { 1: '검토할 시험', 2: '검토 중인 시험', 3: '보류된 시험', 4: '검토 완료', 5: '승인 완료' }
    console.log(
      `%c[상태 변경 요청] id:${payload.id} | ` +
      `state:${payload.state} | ` +
      `admin_check: ${payload.admin_check} (${adminCheckLabel[payload.admin_check] || '?'}) | ` +
      `mark:${payload.mark} | user_id:${payload.user_id}`,
      'color: #1d77ff; font-weight: bold'
    )
    return new Promise((resolve, reject) => {
      axios.put(`/api/v4/exam/review_exam`, {
          type: payload.type,
          id: payload.id,
          admin_check: payload.admin_check,
          state: payload.state,
          mark: payload.mark,
          user_id: payload.user_id,
        })
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(`%c[상태 변경 성공] id:${payload.id} → admin_check:${payload.admin_check} (${adminCheckLabel[payload.admin_check] || '?'})`, 'color: #4EAE03; font-weight: bold')
            resolve(response)
          } else {
            console.warn(`[상태 변경 실패] id:${payload.id}`, response.data)
            reject(response)
          }
        }).catch((error) => {
          console.error(`[상태 변경 오류] id:${payload.id}`, error)
          reject(error)
        })
    })
  },
  // 검토할 시험 큐 우선순위 규칙 (관리자 전용)
  getReviewPriorityRuleList() {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/review_priority_rule').then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  createReviewPriorityRule(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v4/exam/review_priority_rule', {
          name: payload.name,
          priority: payload.priority,
          active: payload.active,
          badge: payload.badge,
          conditions: payload.conditions,
        })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateReviewPriorityRule(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/v4/exam/review_priority_rule/${payload.id}`, {
          name: payload.name,
          priority: payload.priority,
          active: payload.active,
          badge: payload.badge,
          conditions: payload.conditions,
        })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteReviewPriorityRule(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v4/exam/review_priority_rule/${payload.id}`).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // (문제검토할 시험 입력 중인 시험으로 바꾸기)
  changeState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/auto_enter_exam", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // (문제검토 시험 완료 처리할때 사용?)
  changeStateDone(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/auto_enter_exam_done", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // (문제 생성 exam/ /api/v2/exam/question/add)
  createQuestion(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/question/add", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 문제검토 문제신고
  declarationQuestionError(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/divided_image/error/report", payload).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 문제검토 문제수정 태깅 api
  modifyDividedImg(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/divided_image/modify", payload).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 문제검토 문제세팅 response: {result: 'success || fail', data: 1||0} , 1: 작업이 끝나서 이미지들이 생성되었을 경우, 0: pdf,png 받았으면서 작업중이거나 작업 시작 안됬을 때
  // response: {result: 'success || fail', data: {question_divide_state: -2||0||1, answer_divide_state: -2||0||1}}  
  // question_divide_state: 문제, answer_divide_state: 해설 ,-2: 오류, 0: 대기중, 1: 자르기완료
  getFileState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/divided_image/state?exam_subject_id=" + payload,).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 문제검토 문제세팅 자르기 된 압축파일
  getDividedImg(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/question_all_image/png?exam_subject_id=" + payload.exam_subject_id + "&question_number=" + payload.question_number, { responseType: 'arraybuffer' }).then((response) => {
        // 폴더에 다운로드
        // console.log(response);
        // const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        // const link = document.createElement('a')
        // link.href = url;
        // link.setAttribute('download', payload.file_name);
        // document.body.appendChild(link);
        // link.click();

        // if (response.data.result == 'success') {
        //   resolve(response)
        // }
        // reject(response)
        if (response.status)
          resolve(response)

      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 쌍둥이/변형/개념서 기반 AI 생성 문제 상세
  getAiProblemReviewDetail(context, questionId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/exam/ai_problem_review_detail?question_id=${questionId}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  approveAiExam(context, questionId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v2/exam/ai_problem_review_approve', { question_id: Number(questionId) })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteAiExam(context, questionId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v2/exam/ai_problem_review_delete?id=${Number(questionId)}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  resetDividedImg(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/divided_image/reset", payload).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error)
      })
    })
  },
  /// 문제 이미지 호출
  getDividedQuestionImg(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/divided_image/get_q_image", payload).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error)
      })
    })
  },
  /// 선지 이미지 호출
  getDividedNumberQuestionImg(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/divided_image/get_c_images", payload).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error)
      })
    })
  },
  /// 해설 이미지 호출
  getDividedSolveImg(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/divided_image/get_s_image", payload).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error)
      })
    })
  },
  /// 문제검토 완료로 바꾸기
  doneAiExam(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/auto_review_exam_done", payload).then((response) => {
        resolve(response)
      })
    })
  },
  doneAiExamNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v4/exam/review_exam_done", payload).then((response) => {
        resolve(response)
      })
    })
  },
  /// 문제 및 지문과 해설 열람여부 조회  {visit_a: 지문, visit_q: 문제}
  getCheckState(context, payload) {
    // console.log(payload);
    return new Promise((resolve, reject) => {
      axios.get("api/v2/exam/question_visited_check/" + payload.id).then((response) => {
        resolve(response)
      })
    })
  },
  /// 문제 및 지문과 해설 조회시 호출  payload: {id: int, visited_type: 0(문제 조회했을 때)||1(해설 조회했을 때)} 
  putCheckState(context, payload) {
    // console.log(payload);
    return new Promise((resolve, reject) => {
      axios.put("api/v2/exam/question_visited?id=" + payload.id + '&visited_type=' + payload.visited_type).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  /// 신고된 정보들 가져오기 payload: {question_index: int, exam_subject_id: int}
  getErrorInfoList(context, payload) {
    // console.log(payload);
    return new Promise((resolve, reject) => {
      axios.get(`api/v2/exam/question_error_report?exam_subject_id=${payload.exam_subject_id}&question_index=${payload.question_index}`).then((response) => {
        resolve(response)
      })
    })
  },
  /// 시험 상태값 변경 전 가능한지 여부 체크(에러 체크는 프론트에서)
  getCheckExamDone({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/exam/check_exam_done?type=${payload.type}&id=${payload.exam_subject_id}`).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getCheckExamDoneNew({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v4/exam/check_exam_done?type=${payload.type}&id=${payload.exam_subject_id}`).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  /// 신고된 내용 삭제
  removeDeclaration(context, payload) { // payload: {error_id: 230, exam_type: 3,}
    // console.log(payload);
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/divided_image/error/report_cancel", {
        error_id: payload.error_id,
        exam_type: payload.exam_type,
        issue_status: 2,  // 2는 고정임
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  //신고 내용 해결 완
  errorSolved(context, payload) { // payload: {error_id: 230, exam_type: 3,}
    // console.log(payload);
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/divided_image/error/report_cancel", {
        error_id: payload.error_id,
        exam_type: payload.exam_type,
        issue_status: 1,
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 문제검토 확인 완료버튼
  doneExamAdminCheck(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/v2/exam/auto_review_exam/check?id=${payload.id}&type=${payload.type}`).then((response) => {
        resolve(response)
      });
    })
  },
  // 관리자 전용 넘기기 버튼 동작
  skipExam(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/v2/exam/auto_review_exam_force?id=${payload.id}&type=${payload.type}`).then((response) => {
        resolve(response)
      });
    })
  },
  //]
  // 관리자 전용 반려버튼
  // rejectExam(context, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.put(`/api/v2/exam/auto_review_exam/rejection?type=${payload.type}&id=${payload.id}`).then((response) => {
  //       resolve(response)
  //     });
  //   })
  // },
  rejectExam(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/v2/exam/auto_review_exam/return?type=${payload.type}&id=${payload.id}`).then((response) => {
        resolve(response)
      });
    })
  },
  // 반려 수정 완료 버튼
  rejectExamModify(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/api/v2/exam/auto_review_exam/rejection/question_done?id=${payload.id}&type=${payload.type}&question_id=${payload.question_id}`).then((response) => {
        resolve(response)
      });
    })
  },
  //]


  // AI > 생성(중,고등) > 내신 AI ... [
  // ?
  createSchoolSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/auto_school_subject", payload).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_SCHOOL_SUBJECT_ID", response.data.data)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // ? 
  deleteSchoolSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/exam/auto_school_subject/" + payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // ?
  editSchoolSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/auto_school_subject", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 생성된 내신 시험 가져옴(중,고등 통합)
  async getAllAiExamSchoolSubject(context) {
    var middleList = [];
    var highList = [];
    await store.dispatch('aiExam/getAllSchoolSubject', 2).then((res) => {
      if (res.data.result == 'success') middleList = res.data.data_list;
    });
    console.log('중학생 생성된 시험 제대로 가져와짐');
    await store.dispatch('aiExam/getAllSchoolSubject', 3).then((res) => {
      if (res.data.result == 'success') highList = res.data.data_list;
    });
    console.log('고등학생 생성된 시험 제대로 가져와짐');
    var allSchoolList = [...middleList, ...highList];
    store.commit("exam/SET_SCHOOL_SUBJECT_LIST", allSchoolList)
    return allSchoolList;
  },
  // 생성된 내신 시험 가져옴(3: 고등, 2: 중등)
  getAllSchoolSubject(context, type) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_school_subject_list?type=" + type).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_SCHOOL_SUBJECT_LIST", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // ?
  getSchoolSubjectDetail({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_school_subject?id=" + payload).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_SCHOOL_SUBJECT_DETAIL", response.data.data)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 출판사 가져오기 school_type2: 중학생, 3: 고등학생 {school_type: 3, subject_type_id: 1, subject_detail_type_id: 1,} +{grade_id: 1, detail: ''}
  getSchoolPublisher({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/school_subject/publisher?school_type=" + payload.school_type + '&subject_type_id=' + payload.subject_type_id + '&subject_detail_type_id=' + payload.subject_detail_type_id + (payload.school_type == 2 ? `&grade_id=${payload.grade_id}&detail=${payload.detail}` : '')).then((response) => {
        if (response.data.result == 'success') {
          store.commit("exam/SET_SCHOOL_PUBLISHER", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 교과서 가져오기 school_type2: 중학생, 3: 고등학생 {publisher_id: 1, subject_type_id: 1, subject_detail_type_id: 1, school_type: 2,} + {grade_id: 1, detail: ''}
  getPublisherSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/school_subject/textbook_subject?publisher_id=" + payload.publisher_id + "&subject_type_id=" + payload.subject_type_id + "&subject_detail_type_id=" + payload.subject_detail_type_id + "&school_type=" + payload.school_type + (payload.school_type == 2 ? `&grade_id=${payload.grade_id}&detail=${payload.detail}` : '')).then((response) => {
        console.log(response)
        if (response.data.result == 'success') {
          store.commit("book/SET_PUBLISH_SUBJECT_LIST", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  createMiddleSchoolSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/auto_school_subject", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            store.commit("exam/SET_SCHOOL_SUBJECT_ID", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 기출변형 생성된 시험의 정보 가져오기
  getMutateSubjectDetail({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/auto_exam_subject?id=" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            // store.commit("exam/SET_SUBJECT_DETAIL", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 검정고시 시험 생성
  createGedExam(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/ged_exam", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검정고시 시험 과목 추가
  createGedSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/ged_subject", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검정고시 시험 데이터 수정
  editGedSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/ged_subject", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검정고시 동일 시험 체크
  checkGedExam(context, payload) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams({
        school_type: payload.school_type,
        year: payload.year,
        order: payload.order,
      }).toString()
      axios.get(`/api/v2/exam/ged_exam/check?${params}`).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검정고시 생성된 시험의 과목 리스트 가져오기
  getGedSubjectList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/ged_subject_list").then((response) => {
        if (response.data.result == 'success') {
          commit("SET_GED_EXAM_SUBJECT_LIST", response.data.data || [])
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 검정고시 생성된 시험의 정보 가져오기
  getGedSubjectDetail({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/ged_subject?id=" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            store.commit("exam/SET_SUBJECT_DETAIL", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 검정고시 시험 제출(자르기 진행)
  submitGedSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/ged_subject_done?id=" + payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 문제 재작업 (AI 재추출, Codex CLI로 처리)
  getRetryQuestionResult(context, questionId) {
    return axios.get('/api/v4/exam/question', {
      params: { question_id: questionId },
      timeout: 10000,
    })
  },
  getRetryQuestionStatus(context, examSubjectId) {
    return axios.get('/api/v3/ai_system/question_ingestor/retry/status', {
      params: { exam_subject_id: examSubjectId },
      timeout: 10000,
    })
  },
  retryQuestion(context, { examSubjectId, questionNumbers, questionIds, sourceOverrides }) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('exam_subject_id', examSubjectId)
      if (questionIds && questionIds.length) {
        formData.append('question_ids', questionIds.join(','))
      } else {
        formData.append('question_numbers', Array.isArray(questionNumbers) ? questionNumbers.join(',') : String(questionNumbers))
      }
      if (sourceOverrides) formData.append('source_overrides', JSON.stringify(sourceOverrides))
      axios.post('/api/v3/ai_system/question_ingestor/retry', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
    // 우선순위 변경 1 -> 0, 0 -> 1  
  changeTextbookExamPriority(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v4/exam/textbook_exam_priority", {
        id: payload.id,
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        }
        reject(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  
  // ]

  // 고등 기출(신규) v4 APIs
  v4GetExamList() {
    return axios.get('/api/v4/exam/exam_list')
  },
  v4GetExamSubjectList(context, examId) {
    return axios.get(`/api/v4/exam/exam_subject_list?exam_id=${examId}`)
  },
  v4GetExamSubject(context, id) {
    return axios.get(`/api/v4/exam/exam_subject?id=${id}`)
  },
  v4CreateExam(context, payload) {
    return axios.post('/api/v4/exam/exam', payload)
  },
  v4CreateExamSubject(context, payload) {
    return axios.post('/api/v4/exam/exam_subject', payload)
  },
  v4UpdateExamSubject(context, payload) {
    return axios.put('/api/v4/exam/exam_subject', payload)
  },
  v4UpdateExamSubjectFile(context, payload) {
    const frm = new FormData()
    frm.append('id', payload.id)
    frm.append('type', payload.type)
    frm.append('file', payload.file)
    return axios.put('/api/v4/exam/exam_subject_file', frm, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  v4UpdateExamSubjectDone(context, examSubjectId) {
    return axios.put(`/api/v4/exam/exam_subject_done?exam_subject_id=${examSubjectId}`)
  },
  v4DeleteExam(context, examId) {
    return axios.delete(`/api/v4/exam/exam?exam_id=${examId}`)
  },
  v4DeleteExamSubject(context, examSubjectId) {
    return axios.delete(`/api/v4/exam/exam_subject?exam_subject_id=${examSubjectId}`)
  },

  // AI 프롬프트 테스트 (관리자 전용, DB 미저장 — 변형/쌍둥이 문제 생성 프롬프트를 즉석에서 테스트)
  getAiQuestionTestOriginal(context, questionId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v3/ai_system/create_ai_question/test/original?question_id=${questionId}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAiQuestionTest(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v3/ai_system/create_ai_question/test/search', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAiEssayVariantTestSections(context, questionId) {
    return axios.get('/api/v3/ai_system/create_ai_question/test/essay/sections', {
      params: { question_id: questionId || undefined },
    }).then((response) => {
      if (response.data.result == 'success') return response.data
      return Promise.reject(response)
    })
  },
  startGenerateEssayVariantQuestion(context, payload) {
    return axios.post('/api/v3/ai_system/create_ai_question/test/essay/start', payload)
      .then((response) => {
        if (response.data.result == 'success') return response.data
        return Promise.reject(response)
      })
  },
  getAiPromptTestSections() {
    return new Promise((resolve, reject) => {
      axios.get('/api/v3/ai_system/create_ai_question/test/sections')
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 생성 시작 (백그라운드 작업 등록, job_id만 즉시 반환 — 서버 타임아웃 60초 회피용)
  startGenerateVariantQuestion(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_ai_question/test/start', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 생성 상태 폴링
  getGenerateVariantStatus(context, jobId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v3/ai_system/create_ai_question/test/status?job_id=${jobId}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 이미지 생성 테스트 — 문제 텍스트로 이미지 프롬프트 초안 생성 (백그라운드 job, status는 getGenerateVariantStatus 재사용)
  startDraftAiQuestionImagePrompt(context, questionId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_ai_question/test/image/draft_prompt', { question_id: questionId })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 이미지 생성 테스트 — 프롬프트로 Codex 이미지 생성 (백그라운드 job, status는 getGenerateVariantStatus 재사용)
  // 예전엔 Gemini 전용 엔드포인트(test/image/start)를 썼으나, Codex 전환 후 image_gen_codex/start로 통일.
  startGenerateQuestionImage(context, prompt) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_ai_question/test/image_gen_codex/start', { prompt, images_base64: [] })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // Codex 이미지 생성 테스트 — 프롬프트(+선택적 참조/편집 이미지)로 Codex CLI 내장 image_gen(구독 계정)
  // 이미지 생성 (백그라운드 job, status는 getGenerateVariantStatus 재사용)
  // payload: { prompt, imagesBase64 } — imagesBase64는 생략 가능한 base64 문자열 배열
  startCodexImageGen(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_ai_question/test/image_gen_codex/start', {
        prompt: payload.prompt,
        images_base64: payload.imagesBase64 || [],
      })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 도형 그리기 테스트 — 문제 텍스트로 다이어그램 스펙 초안 생성 (백그라운드 job, status는 getGenerateVariantStatus 재사용)
  // payload: { questionId, diagramKind } — diagramKind 생략 시 'legacy_shape'(삼각형/사각형/원 자동 판별)
  startDraftShapeSpec(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_ai_question/test/shape/draft', {
        question_id: payload.questionId,
        diagram_kind: payload.diagramKind,
      })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 도형 그리기 테스트 — 스펙으로 matplotlib 렌더링 (동기 응답, job 아님)
  renderShapeDiagram(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_ai_question/test/shape/render', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // AI 프롬프트 테스트 — 개념서 기반 객관식 문제 생성 (관리자 전용, DB 미저장)
  // 생성 상태 폴링은 기존 getGenerateVariantStatus를 재사용한다 (job_id 저장소가 전역 공용).
  getConceptBookQuestionTestOriginal(context, conceptBookId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v3/ai_system/create_concept_book_question/test/original?concept_book_id=${conceptBookId}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchConceptBookQuestionTest(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v3/ai_system/create_concept_book_question/test/search', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getConceptBookQuestionTestSections(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v3/ai_system/create_concept_book_question/test/sections', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 이미지 전제형 테스트 페이지 전용 섹션 조회 — 위 액션과 달리 SEC_13_IMAGE_ONLY/
  // SEC_15_SELF_REVIEW_IMAGE_ONLY(실제 이미지 전제형 생성이 쓰는 섹션)를 반환한다.
  getConceptBookQuestionImagePremisedTestSections(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v3/ai_system/create_concept_book_question/test/image_premised/sections', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  startGenerateConceptBookQuestionTest(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_concept_book_question/test/start', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // AI 프롬프트 테스트 — 개념서 기반 객관식 문제 생성 (이미지 전제형, '유형 2', 관리자 전용, DB 미저장).
  // 일반 생성 프롬프트와 완전히 독립된 전용 프롬프트이며, 모든 문항이 예외 없이 이미지 전제형 + shape_spec.
  startGenerateConceptBookQuestionImagePremisedTest(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_concept_book_question/test/image_premised/start', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 방금 생성된 이미지 전제형 문제 배치를 사후에 별도로 검토(적합성·난이도·완성도) —
  // 문제 생성(startGenerateConceptBookQuestionImagePremisedTest)과는 완전히 분리된 독립 호출.
  // 상태 폴링은 getGenerateVariantStatus 재사용.
  startReviewConceptBookQuestionImagePremisedTest(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_concept_book_question/test/image_premised/review', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 이미 생성된(테스트 화면에 표시된) 문항 하나에 대해 need_image/image_description/shape_spec을
  // 별도로 판단 (문제 생성 자체는 startGenerateConceptBookQuestionTest를 그대로 재사용).
  startDraftConceptBookImagePrompt(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_concept_book_question/test/image/draft', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // shape_spec.shape_type이 'none'이 아닌 문항을 matplotlib으로 직접 렌더링 (Gemini 미사용, 동기 응답 — job 아님)
  renderConceptBookShapeSpec(context, shapeSpec) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v3/ai_system/create_concept_book_question/test/image/render_shape', { shape_spec: shapeSpec })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 관리 > 문제 관리 > 문제 기반 쌍둥이/변형 문제 생성 페이지
  // 유형(대/중/소)/목차(대/중/소)별 원본 대상 수·대기 등록 수·생성 수·승인/미승인 수 집계
  getVariantQuestionManageSummary(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v3/ai_system/question/variant_manage/summary', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 특정 유형/목차(leaf) 안의 원본 대상 문제 목록 + 생성된 자식 문제 정보
  searchVariantQuestionManageList(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v3/ai_system/question/variant_manage/list', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 원본 문제 1건을 쌍둥이/변형 생성 대기열에 등록(queued=true) / 해제(queued=false)
  setVariantQuestionManageParentState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v3/ai_system/question/variant_manage/parent_state', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 모의고사 전용 변형문제(parent_state/parent_relation=4)
  getMockVariantSubjects(context, examId) {
    return axios.get(`/api/v3/ai_system/mock_exam_variant/subjects?exam_id=${examId}`)
  },
  getMockVariantSubjectQuestions(context, subject) {
    return axios.get(`/api/v3/ai_system/mock_exam_variant/subjects/${subject.id}/questions`, {
      params: { exam_type: subject.exam_type },
    }).then((response) => {
      if (response.data.result == 'success') return response.data
      return Promise.reject(response.data)
    })
  },
  registerMockVariantQuestions(context, payload) {
    return axios.post('/api/v3/ai_system/mock_exam_variant/questions/register', payload).then((response) => {
      if (response.data.result == 'success') return response.data
      return Promise.reject(response.data)
    })
  },
}
